import React, { useCallback, useEffect, Suspense } from 'react';
import { observer } from 'mobx-react';

import VerticalAds from '../../components/Adds/VerticalAds';
import LiveBanner from '../../components/anchorComponents/LiveBanner';
import NNLiveSchedule from '../../components/anchorComponents/NNLiveSchedule';
import SimpleVideoPlayer from '../../components/blogComponents/SimpleVideoPlayer';
import ContextualJoinOverlay from '../../components/generalComponents/ContextualJoinOverlay/ContextualJoinOverlay';
import TulumRealityShowStore from '../../store/TulumRealityShowStore';
import LiveBroadcastStore from '../../store/LiveBroadcastStore';
import { getActiveRealityShow } from '../../services/RealityShowServices';

import TulumRealityShow from './TulumRealityShow/TulumRealityShow';


const REALITY_SHOW = 'REALITY_SHOW';

const FeaturedSection = React.lazy(() => import('../../components/anchorComponents/FeaturedSection'));


const NakedNewsLivePage = observer((props) => {
  const {
    anchor,
    anchorId,
    anchorVideoUrl,
    chatService,
    chatServiceTem,
    extractIdFromSlug,
    guestUser,
    history,
    toggleContextualJoinOverlay,
    slug,
    user,
    onNetworkError,
    galleriesAndVideosCount,
    anchorPortalCampaign,
    showOverlay,
    pageItemsShown,
    setBanStatus,
    setItemsCount,
    location,
    fetchStreamDetails,
    isSpotlighing,
    spotlighedAnchorNickname,
    spotlighedAnchorUsername,
    livePageAdData,
    nakedNewsLivePromoClip,
    nakedNewsLivePromoImage,
    nakedNewsLiveAnchorData,
    setNakedNewsLivePageAd,
    setNakedNewsLivePromoUrl,
    userCanAccessSpecialEvent,
  } = props;

  const { streams } = TulumRealityShowStore;
  const { streamStarted } = LiveBroadcastStore;

  const bannerProps = {
    anchor,
    anchorId,
    anchorVideoUrl,
    chatService,
    chatServiceTempted: chatServiceTem,
    extractIdFromSlug,
    fetchStreamDetails,
    galleriesAndVideosCount,
    guestUser,
    history,
    isLivePage: true,
    isSpotlighing,
    nakedNewsLiveAnchorData,
    openContextualOverlay: toggleContextualJoinOverlay,
    slug,
    spotlighedAnchorNickname,
    spotlighedAnchorUsername,
    user,
    onNetworkError,
  };

  const setUserCanAccessRealityShow = async() => {
    const realityShowCFExists = user?.temptedFeatures?.includes(REALITY_SHOW);
    if (realityShowCFExists) {
      const { error, data } = await getActiveRealityShow();
      const userCanAccessShow = realityShowCFExists && data?.data?.length;
      if (!error) {
        LiveBroadcastStore.setUserCanAccessSpecialEvent(userCanAccessShow);
      }
    }
  };

  const getBannerToDisplay = useCallback(() => {
    if (userCanAccessSpecialEvent && !streamStarted && streams) {
      return (<TulumRealityShow {...bannerProps} />);
    }

    return (<LiveBanner {...bannerProps} />);
  }, [bannerProps, userCanAccessSpecialEvent, streamStarted, streams]);


  useEffect(() => {
    setUserCanAccessRealityShow();
    if (userCanAccessSpecialEvent) {
      TulumRealityShowStore.getRealityShowsStreamsAndStartPoll();
    }

    return () => TulumRealityShowStore.reset();

  }, [userCanAccessSpecialEvent]);

  if (!anchor) {
    return null;
  }

  return (
    <>
      {getBannerToDisplay()}
      <div className="bio-ad-container live-page">
        <div className="col-md-6 com-sm-12 col-xs-12 anchor-fan-zone-free-video live">
          <VerticalAds adData={livePageAdData} />
          <SimpleVideoPlayer
            clip={{ videoUrl: nakedNewsLivePromoClip, imageUrl: nakedNewsLivePromoImage }}
            fanZoneFreeVideo={true}
            user={user}
          />
        </div>
        <NNLiveSchedule setNakedNewsLivePageAd={setNakedNewsLivePageAd} />
      </div>
      <ContextualJoinOverlay
        anchorId={anchorId}
        anchorPortalCampaign={anchorPortalCampaign}
        anchorShortUrl={slug}
        closeContextualOverlay={toggleContextualJoinOverlay}
        history={history}
        setNakedNewsLivePromoUrl={setNakedNewsLivePromoUrl}
        showOverlay={showOverlay}
        user={user}
      />
      <Suspense fallback={null}>
        <FeaturedSection
          anchorName={anchor?.name}
          anchorShortUrl={slug}
          extractIdFromSlug={extractIdFromSlug}
          galleriesAndVideosCount={galleriesAndVideosCount}
          id={anchorId}
          isNakedNewsLive={true}
          location={location}
          pageItemsShown={pageItemsShown}
          setBanStatus={setBanStatus}
          setItemsCount={setItemsCount}
          showClipStore={anchor?.clipStoreItemsCount > 0}
          user={user}
        />
      </Suspense>
    </>
  );
});

export default NakedNewsLivePage;
